import { FC, useCallback, useEffect, useState } from 'react';
import './offline-modal.less';
import { SvgIcon, Modal, Loading, Button } from '@/components';
import { apiService, appVers, WidgetInfo } from '@/shared';
import { useImmer } from 'use-immer';
import classnames from 'classnames';
import Message from 'rc-message';

interface OffLineModalProps {
  visible: boolean;
  info?: WidgetInfo;
  appId?: number;
  close?: (bool: boolean) => void;
}
interface OnLineVersionItem {
  ac: boolean;
  key: number | 'all';
  value: string;
}
const OffLineModal: FC<OffLineModalProps> = ({
  visible = false,
  info = {} as WidgetInfo,
  appId = 0,
  close = (bool = false) => {},
}) => {
  const [onlineV, setOnlineV] = useImmer<OnLineVersionItem[]>([]);
  const [selectAll, setSelectAll] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  // 获取已经上线的
  const getOnlineAppVersionsFn = useCallback(
    async (info) => {
      setLoading(true);
      try {
        const res = await apiService.onlineAppVersions({
          abilityCode: info.abilityCode,
          abilityImplCode: info.code,
          appId: appId,
        });
        if (res?.length) {
          const temp = res.map((item: string, index: number) => ({
            ac: info.appVersionName === item,
            key: index,
            value: item,
          }));
          setOnlineV(temp);
        }
      } catch (error) {
      } finally {
        setLoading(false);
      }
    },
    [setOnlineV, appId],
  );
  // clear
  const clear = useCallback(() => {
    setOnlineV([]);
    setSelectAll(false);
  }, [setOnlineV, setSelectAll]);

  // 下线
  const updateStatusFn = useCallback(async () => {
    try {
      const res = await apiService.offLineWidget({
        wdId: info.widgetId,
        versionList: onlineV
          .filter((item) => item.ac)
          .map((item) => String(item.key)),
      });
      if (res === true) {
        close(true);
        clear();
      }
    } catch (error) {}
  }, [onlineV, close, info, clear]);
  useEffect(() => {
    if (visible && info?.id && info.appVers) {
      const temp = info.appVers.map((item: appVers, index: number) => ({
        ac: false,
        key: item.verCode,
        value: item.verName,
      }));
      setOnlineV(temp);
    }
  }, [visible, info]);
  useEffect(() => {
    const selectAll = onlineV.every((d) => d.ac);
    setSelectAll(selectAll);
  }, [onlineV]);
  return (
    <Modal className="offline-modal" visible={visible}>
      <div className="tit-div">请确认下架版本</div>
      <div className="dis">
        发现您名称为「{info?.name}
        」的小部件在多个应用版本有上线，请确认需要下架的版本：
      </div>
      <Loading loading={loading}>
        <ul className="v-ul clearfix">
          {onlineV.map((item: OnLineVersionItem, index: number) => {
            const type = onlineV.length === 1 ? 'xs' : 's';
            return (
              <li
                key={index}
                className={classnames({ ac: item.ac, [type]: true })}
                onClick={() => {
                  setOnlineV((draft) => {
                    if (item.key === 'all') {
                      draft.forEach((d) => {
                        d.ac = !item.ac;
                      });
                    } else {
                      draft.forEach((d) => {
                        if (d.value === item.value) {
                          d.ac = !d.ac;
                        }
                      });
                    }
                  });
                }}
              >
                <span className="value" title={item.value}>
                  {item.value}
                </span>
                <SvgIcon
                  style={{
                    marginRight: '5px',
                    fill: '#0476eb',
                    visibility: item.ac ? 'visible' : 'hidden',
                  }}
                  className="cursor yes"
                  name="yes"
                  width={type === 'xs' ? '20' : '12'}
                  height={type === 'xs' ? '15' : '8'}
                />
              </li>
            );
          })}
          {onlineV.length > 1 && (
            <li
              className={classnames({ ac: selectAll })}
              onClick={() => {
                setOnlineV((draft) => {
                  draft.forEach((d) => {
                    d.ac = !selectAll;
                  });
                });
              }}
            >
              <span>全部</span>
              <SvgIcon
                style={{
                  marginRight: '10px',
                  fill: '#0476eb',
                  visibility: selectAll ? 'visible' : 'hidden',
                }}
                className="cursor"
                name="yes"
                width={'12'}
                height={'8'}
              />
            </li>
          )}
        </ul>
      </Loading>
      <Button
        type="primary"
        className="dbi"
        onClick={() => {
          if (onlineV.every((d) => !d.ac)) {
            Message.error({
              content: '至少选择一个版本',
            });
            return;
          }
          updateStatusFn();
        }}
      >
        确认下架
      </Button>
      <Button
        className="dbi"
        onClick={() => {
          clear();
          close(false);
        }}
      >
        取消
      </Button>
      <p className="p-b">下架后将无法在小部件商店进行展示</p>
    </Modal>
  );
};
export default OffLineModal;
